import axiosInstance from "@/api/axiosInstance";
import { PublishResponse } from "../types";

/**
 * Publish a hero item
 * POST /api/admin/hero-items/{id}/publish
 */
export async function publishHeroItem(id: string): Promise<PublishResponse> {
  const response = await axiosInstance.post<PublishResponse>(
    `/api/admin/hero-items/${id}/publish`,
  );
  return response.data;
}
